import { getInternalServerConfig, validateServerConfig } from './auth';

export const validateSettings = () => {
  const internalServer = getInternalServerConfig();
  const errors = validateServerConfig(internalServer, 'Internal API');

  return {
    isValid: errors.length === 0,
    errors
  };
};
